import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutContext } from '../../../../layout-context.model';
import { AppRoutes } from '@app/core/routing';
import { IconComponent } from '@app/ui';

/**
 * Quietest footer variant — a single hairline-topped row for focused flows
 * (checkout). Left: the tenant legal line (©year, charity name, registered
 * charity number). Right: the legal links the `simple` footer carries plus a
 * lock + "Secure checkout" microlabel (the Etsy-checkout pattern). No nav, no
 * social, no "Powered by" upsell — nothing that competes with the payment
 * form above it.
 */
@Component({
  selector: 'gb-footer-minimal',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './footer-minimal.component.html',
  styleUrls: ['./footer-minimal.component.scss'],
})
export class FooterMinimalComponent {
  protected readonly AppRoutes = AppRoutes;

  @Input({ required: true }) ctx!: LayoutContext;

  readonly year = new Date().getFullYear();
}
